import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EnvService } from "src/app/env.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ModelsService {
  BASE_URL;
  constructor(
    private http: HttpClient,
    private env: EnvService,
  ) {
    this.BASE_URL = env.apiUrl + "models/";
  }

  searchTemplates(data): Observable<any> {
    return this.http.post(this.BASE_URL + "search/", data);
  }
  getTemplates(): Observable<any> {
    return this.http.get(this.BASE_URL + "get-all");
  }
  getTemplate(id): Observable<any> {
    return this.http.get(this.BASE_URL + "get/" + id);
  }
  deleteTemplate(id): Observable<any> {
    return this.http.get(this.BASE_URL + "delete/" + id);
  }
  createTemplate(data?): Observable<any> {
    return this.http.post(this.BASE_URL + "create/", data || {});
  }
  editTemplate(data): Observable<any> {
    return this.http.post(this.BASE_URL + "edit/", data);
  }
  addSubTemplate(data): Observable<any> {
    return this.http.post(this.BASE_URL + "add/", data || {});
  }
  removeSubtemplates(data): Observable<any> {
    return this.http.post(this.BASE_URL + "remove/", data);
  }
  startFinetuning(data) {
    return this.http.post(this.BASE_URL + "start-finetuning/", data);
  }

  getFinetuningStatus(data) {
    return this.http.post(this.BASE_URL + "status-finetuning/", data);
  }

  cancelFineTuningJob(data) {
    return this.http.post(this.BASE_URL + "cancel-finetuning/", data);
  }
  deleteFineTunedModel(data) {
    return this.http.post(this.BASE_URL + "delete-finetuning/", data);
  }

  generateTemplateWithAI(data: { exampleText?: string; instructions?: string; files?: string[]; language: string; currentTemplate?: string }): Observable<any> {
    return this.http.post(this.BASE_URL + "generate-with-ai", data);
  }
}
